import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Compoments
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import Header from '../../components/layouts/header';
import FormUploadPdf from '../../components/forms/FormUploadPdf'
import Body from '../../components/layouts/body';


class UploadsPdf extends React.Component {
        
    render() {
        return (
            <>            
            <DashboardMenu />
            <Header titulo="Uploads" subtitulo="PDF" descricao="" />
            <Body>               
                <FormUploadPdf />
            </Body>
            </>
        )
    }
}

export default connect()(withRouter(UploadsPdf));